// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { $delete, createOrUpdate, get } from "./operations.js";
export type {
  ManagementPoliciesDeleteOptionalParams,
  ManagementPoliciesCreateOrUpdateOptionalParams,
  ManagementPoliciesGetOptionalParams,
} from "./options.js";
